import { Table } from '@zillow/constellation';
import React from 'react';
import { RATE_COMPARES } from './MortgageRatesTable.js';

var MortgageRatesTableHeader = function MortgageRatesTableHeader(_ref) {
  var columns = _ref.columns,
    rateCompare = _ref.rateCompare;
  return /*#__PURE__*/React.createElement(Table.Header, null, /*#__PURE__*/React.createElement(Table.Row, null, /*#__PURE__*/React.createElement(Table.HeaderCell, {
    width: "50%"
  }, "Program"), columns.includes('rate') && /*#__PURE__*/React.createElement(Table.HeaderCell, null, "Rate"), columns.includes('rateChange') && /*#__PURE__*/React.createElement(Table.HeaderCell, null, RATE_COMPARES[rateCompare], " Change"), columns.includes('apr') && /*#__PURE__*/React.createElement(Table.HeaderCell, null, "APR"), columns.includes('aprChange') && /*#__PURE__*/React.createElement(Table.HeaderCell, null, RATE_COMPARES[rateCompare], " Change")));
};
var MortgageRatesTableHeader$1 = MortgageRatesTableHeader;

export { MortgageRatesTableHeader$1 as default };
